import React, { useState } from 'react';

import { EditIcon } from '~/Components/Icons/Icons'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import AdminViewUserAccount from './AdminViewUserAccount';
import { toast } from 'react-toastify';


const AdminRegistrationCommunications = ({ invitation, match, event, onChange, ...props }) => {

    if (!invitation) {
        return <></>;
    }

    const emails = invitation?.user?.receiver_emails || [];
    const [ccEditMode, setCcEditMode] = useState(false);
    const [ccValue, setCcValue] = useState(invitation.user.cc_email);
    const [error, setError] = useState(null);
    const types = {
        invitation: 'Guest invitation',
        accepted: 'RSVP Accepted',
        declined: 'RSVP Declined',
        new_code: 'Code Reminder',
        host: 'Host Invitation',
        pre_event: 'Pre Event',
        event_survey: 'Event Survey',
        reminder: 'Reminder'
    };

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post('/events/' + event.id + '/invitations/' + invitation.id + '/cc', { cc: ccValue }),
            {
                pending: 'Saving...',
                success: {
                    render() {
                        setError(null);
                        setCcEditMode(false);

                        if (onChange) {
                            onChange();
                        }
                        return 'CC emails saved'
                    }
                },
                error: {
                    render(err) {
                        setError(err.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (
        <div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2>Communications</h2>
                        <AdminViewUserAccount
                            className="btn btn-secondary btn-icon btn-sm mr-3"
                            guest={invitation.user}
                            code={invitation.code}
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-2 text-primary font-weight-500">Email</div>
                <div className="col-8">{invitation.main_guest?.email || invitation.user.email}</div>
            </div>
            <div className="row">
                <div className="col-2 text-primary font-weight-500">CC Emails</div>

                {!ccEditMode && (
                    <div className="col-8">
                        {invitation.user.cc_email} <a className="cursor-pointer" onClick={() => setCcEditMode(true)}><EditIcon /></a>
                    </div>
                )}

                {ccEditMode && (
                    <>
                        <div className="col-8">

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error.message || "Error saving cc!"}
                                </div>
                            )}

                            <textarea rows={5} className="form-control" type="text" value={ccValue} onChange={e => setCcValue(e.target.value)} />

                            <small>Comma separated list of email addresses.</small>
                            <ValidationError errors={error?.errors} name="cc" />

                        </div>
                        <div className="col-2">
                            <a className="text-caption text-primary cursor-pointer mr-2" onClick={() => setCcEditMode(false)}>Cancel</a>
                            <a className="text-caption text-primary cursor-pointer" onClick={() => handleSubmit()}>Save</a>
                        </div>
                    </>
                )}
            </div>

            <div className="row mt-4">
                <div className="col-12">
                    <h2 className="mb-3">Logs</h2>
                </div>

                <div className="table-scrollable">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Status</th>
                                <th scope="col">Type</th>
                                <th scope="col">Language</th>
                                <th scope="col">Sent at</th>
                                <th scope="col">Subject</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails.map((email, index) =>
                                <tr key={`guest-email_${index}`}>
                                    <td>{email?.name || '-'}</td>
                                    <td>{email?.email || '-'}</td>
                                    <td className="text-capitalize">{email?.status || '-'}</td>
                                    <td className="text-capitalize">{types[email.type]}</td>
                                    <td className="text-capitalize">{email?.language?.name || 'English'}</td>
                                    <td>{email?.sent_at || '-'}</td>
                                    <td>{email?.subject || '-'}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(withRouter(AdminRegistrationCommunications));
